module.exports = __webpack_public_path__ + "img/ta5.4d32c6ee.png";